/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { DESCRIPTION, TITLE } from "./constants";
import { Wrapper, Title, Description } from "./styled";

const Header = () => {
  return (
    <Wrapper>
      <Title>{TITLE}</Title>
      <Description>{DESCRIPTION}</Description>
    </Wrapper>
  );
};

export default Header;
